export const MONTHLY_ANALYTICS_MOCK = {
  series: [
    {
      period: '2025/01',
      start: '2025-01-01T00:00:00.000Z',
      end: '2025-02-01T00:00:00.000Z',
      rows: [
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 86365180.6736,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 80468912.93539426,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 83412841.1771117,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 45454331.82999992,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 45288362.68999997,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 17707150.2,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 8112008.451100009,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 8054447.125,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 74307.4,
          sum: 2192442.2800000007,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1971420.0999999996,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 7576000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 3317868.14,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 3342204,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 3408000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1451543.2437999998,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1583847.943,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 139500.00000000035,
          sum: 13602450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 9974947.529724443,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 11251144.210852196,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1016490.51,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1121450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 44014001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 4303484.015000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 5694992.380000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 238663.91000000003,
          sum: 5863550.740000002,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 435139.01,
          sum: 6007571.820000002,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 728000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 630044.1932740004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 649123.46,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1516484.0088890004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1493837,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1445199,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1458003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 417713.93356000003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 417937.44899999996,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 45158.8761662,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 45158.873500000016,
        },
      ],
    },
    {
      period: '2025/02',
      start: '2025-02-01T00:00:00.001Z',
      end: '2025-03-01T00:00:00.000Z',
      rows: [
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 86365180.6736,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 80468912.93539426,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 83412841.1771117,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 45454331.82999992,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 45288362.68999997,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 17707150.2,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 8112008.451100009,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 8054447.125,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 74520.12,
          sum: 2266962.400000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 152130.2,
          sum: 2123550.3,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 7576000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 3317868.14,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 3342204,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 3408000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1451543.2437999998,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1583847.943,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 126000,
          sum: 13728450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 9974947.529724443,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 11251144.210852196,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1016490.51,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1121450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 44014001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 4303484.015000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 5694992.380000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 316383.29000000004,
          sum: 6179934.030000003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 583333.3399999999,
          sum: 6590905.160000003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 728000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 630044.1932740004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 649123.46,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1516484.0088890004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1493837,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1445199,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1458003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 417713.93356000003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 417937.44899999996,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 45158.8761662,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 45158.873500000016,
        },
      ],
    },
    {
      period: '2025/03',
      start: '2025-03-01T00:00:00.001Z',
      end: '2025-04-01T00:00:00.000Z',
      rows: [
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 86365180.6736,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 80468912.93539426,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 83412841.1771117,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 45454331.82999992,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 45288362.68999997,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 17707150.2,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 8112008.451100009,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 8054447.125,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 75532.01,
          sum: 2342494.410000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 230385.30000000002,
          sum: 2353935.6,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 7576000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 3317868.14,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 3342204,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 3408000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1451543.2437999998,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1583847.943,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 139500.00000000035,
          sum: 13867950,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 9974947.529724443,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 11251144.210852196,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1016490.51,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1121450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 44014001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 4303484.015000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 5694992.380000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 295381.08,
          sum: 6475315.110000002,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 874970.0099999998,
          sum: 7465875.1700000055,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 728000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 630044.1932740004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 649123.46,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1516484.0088890004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1493837,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1445199,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1458003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 417713.93356000003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 417937.44899999996,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 45158.8761662,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 45158.873500000016,
        },
      ],
    },
    {
      period: '2025/04',
      start: '2025-04-01T00:00:00.001Z',
      end: '2025-05-01T00:00:00.000Z',
      rows: [
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 86365180.6736,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 80468912.93539426,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 83412841.1771117,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 45454331.82999992,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 45288362.68999997,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 17707150.2,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 8112008.451100009,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 8054447.125,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 74719.20999999999,
          sum: 2417213.620000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 304260.4,
          sum: 2658196.0000000005,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 7576000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 3317868.14,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 3342204,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 3408000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1451543.2437999998,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1583847.943,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 134999.99999999965,
          sum: 14002950,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 9974947.529724443,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 11251144.210852196,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1016490.51,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1121450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 44014001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 4303484.015000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 5694992.380000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 6475315.110000002,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 1000000.0099999998,
          sum: 8465875.180000007,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 728000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 630044.1932740004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 649123.46,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1516484.0088890004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1493837,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1445199,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1458003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 417713.93356000003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 417937.44899999996,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 45158.8761662,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 45158.873500000016,
        },
      ],
    },
    {
      period: '2025/05',
      start: '2025-05-01T00:00:00.001Z',
      end: '2025-06-01T00:00:00.000Z',
      rows: [
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 86365180.6736,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 80468912.93539426,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 83412841.1771117,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 45454331.82999992,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 45288362.68999997,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 17707150.2,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 8112008.451100009,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 8054447.125,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 2417213.620000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 2658196.0000000005,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 7576000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 3317868.14,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 3342204,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 3408000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1451543.2437999998,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1583847.943,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 139500,
          sum: 14142450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 9974947.529724443,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 11251144.210852196,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1016490.51,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1121450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 44014001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 4303484.015000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 5694992.380000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 6475315.110000002,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 708333.3399999999,
          sum: 9174208.520000007,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 728000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 630044.1932740004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 649123.46,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1516484.0088890004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1493837,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1445199,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1458003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 417713.93356000003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 417937.44899999996,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 45158.8761662,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 45158.873500000016,
        },
      ],
    },
    {
      period: '2025/06',
      start: '2025-06-01T00:00:00.001Z',
      end: '2025-07-01T00:00:00.000Z',
      rows: [
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 86365180.6736,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 80468912.93539426,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 83412841.1771117,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 45454331.82999992,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 45288362.68999997,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 17707150.2,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 8112008.451100009,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 8054447.125,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 2417213.620000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 2658196.0000000005,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 7576000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 3317868.14,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 3342204,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 3408000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1451543.2437999998,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1583847.943,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 135000,
          sum: 14277450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 9974947.529724443,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 11251144.210852196,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1016490.51,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1121450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 44014001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 4303484.015000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 5694992.380000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 6475315.110000002,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 416666.67,
          sum: 9590875.190000007,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 728000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 630044.1932740004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 649123.46,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1516484.0088890004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1493837,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1445199,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1458003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 417713.93356000003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 417937.44899999996,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 45158.8761662,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 45158.873500000016,
        },
      ],
    },
    {
      period: '2025/07',
      start: '2025-07-01T00:00:00.001Z',
      end: '2025-08-01T00:00:00.000Z',
      rows: [
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 86365180.6736,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 80468912.93539426,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 83412841.1771117,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 45454331.82999992,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 45288362.68999997,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 17707150.2,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 8112008.451100009,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 8054447.125,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 2417213.620000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 2658196.0000000005,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 7576000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 3317868.14,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 3342204,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 3408000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1451543.2437999998,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1583847.943,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 139500,
          sum: 14416950,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 9974947.529724443,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 11251144.210852196,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1016490.51,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1121450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 44014001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 4303484.015000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 5694992.380000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 6475315.110000002,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 9590875.190000007,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 728000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 630044.1932740004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 649123.46,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1516484.0088890004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1493837,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1445199,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1458003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 417713.93356000003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 417937.44899999996,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 45158.8761662,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 45158.873500000016,
        },
      ],
    },
    {
      period: '2025/08',
      start: '2025-08-01T00:00:00.001Z',
      end: '2025-09-01T00:00:00.000Z',
      rows: [
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 86365180.6736,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 80468912.93539426,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 83412841.1771117,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 45454331.82999992,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 45288362.68999997,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 17707150.2,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 8112008.451100009,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 8054447.125,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 2417213.620000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 2658196.0000000005,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 7576000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 3317868.14,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 3342204,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 3408000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1451543.2437999998,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1583847.943,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 139500,
          sum: 14556450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 9974947.529724443,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 11251144.210852196,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1016490.51,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1121450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 44014001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 4303484.015000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 5694992.380000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 6475315.110000002,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 9590875.190000007,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 728000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 630044.1932740004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 649123.46,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1516484.0088890004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1493837,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1445199,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1458003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 417713.93356000003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 417937.44899999996,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 45158.8761662,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 45158.873500000016,
        },
      ],
    },
    {
      period: '2025/09',
      start: '2025-09-01T00:00:00.001Z',
      end: '2025-10-01T00:00:00.000Z',
      rows: [
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 86365180.6736,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 80468912.93539426,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 83412841.1771117,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 45454331.82999992,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 45288362.68999997,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 17707150.2,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 8112008.451100009,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 8054447.125,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 2417213.620000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 2658196.0000000005,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 7576000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 3317868.14,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 3342204,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 3408000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1451543.2437999998,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1583847.943,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 135000,
          sum: 14691450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 9974947.529724443,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 11251144.210852196,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1016490.51,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1121450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 44014001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 4303484.015000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 5694992.380000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 6475315.110000002,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 9590875.190000007,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 728000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 630044.1932740004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 649123.46,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1516484.0088890004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1493837,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1445199,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1458003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 417713.93356000003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 417937.44899999996,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 45158.8761662,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 45158.873500000016,
        },
      ],
    },
    {
      period: '2025/10',
      start: '2025-10-01T00:00:00.001Z',
      end: '2025-11-01T00:00:00.000Z',
      rows: [
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 86365180.6736,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 80468912.93539426,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 83412841.1771117,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 45454331.82999992,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 45288362.68999997,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 17707150.2,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 8112008.451100009,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 8054447.125,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 2417213.620000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 2658196.0000000005,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 7576000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 3317868.14,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 3342204,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 3408000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1451543.2437999998,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1583847.943,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 139500,
          sum: 14830950,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 9974947.529724443,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 11251144.210852196,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1016490.51,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1121450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 44014001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 4303484.015000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 5694992.380000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 6475315.110000002,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 9590875.190000007,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 728000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 630044.1932740004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 649123.46,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1516484.0088890004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1493837,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1445199,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1458003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 417713.93356000003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 417937.44899999996,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 45158.8761662,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 45158.873500000016,
        },
      ],
    },
    {
      period: '2025/11',
      start: '2025-11-01T00:00:00.001Z',
      end: '2025-12-01T00:00:00.000Z',
      rows: [
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 86365180.6736,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 80468912.93539426,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 83412841.1771117,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 45454331.82999992,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 45288362.68999997,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 17707150.2,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 8112008.451100009,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 8054447.125,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 2417213.620000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 2658196.0000000005,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 7576000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 3317868.14,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 3342204,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 3408000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1451543.2437999998,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1583847.943,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 135000,
          sum: 14965950,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 9974947.529724443,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 11251144.210852196,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1016490.51,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1121450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 44014001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 4303484.015000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 5694992.380000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 6475315.110000002,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 9590875.190000007,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 728000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 630044.1932740004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 649123.46,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1516484.0088890004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1493837,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1445199,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1458003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 417713.93356000003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 417937.44899999996,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 45158.8761662,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 45158.873500000016,
        },
      ],
    },
    {
      period: '2025/12',
      start: '2025-12-01T00:00:00.001Z',
      end: '2026-01-01T00:00:00.000Z',
      rows: [
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 86365180.6736,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 80468912.93539426,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 83412841.1771117,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 45454331.82999992,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 45288362.68999997,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 17707150.2,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 8112008.451100009,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 8054447.125,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 2417213.620000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 2658196.0000000005,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 7576000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 3317868.14,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 3342204,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 3408000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1451543.2437999998,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1583847.943,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 139500,
          sum: 15105450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 9974947.529724443,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 11251144.210852196,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1016490.51,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1121450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 44014001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 4303484.015000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 5694992.380000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 6475315.110000002,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 9590875.190000007,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 728000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 630044.1932740004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 649123.46,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1516484.0088890004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1493837,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1445199,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1458003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 417713.93356000003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 417937.44899999996,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 45158.8761662,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 45158.873500000016,
        },
      ],
    },
    {
      period: '2026/01',
      start: '2026-01-01T00:00:00.001Z',
      end: '2026-02-01T00:00:00.000Z',
      rows: [
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 86365180.6736,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 80468912.93539426,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 83412841.1771117,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 45454331.82999992,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 45288362.68999997,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 17707150.2,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 8112008.451100009,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 8054447.125,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 2417213.620000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 2658196.0000000005,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 7576000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 3317868.14,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 3342204,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 3408000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1451543.2437999998,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1583847.943,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 139500,
          sum: 15244950,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 9974947.529724443,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 11251144.210852196,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1016490.51,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1121450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 44014001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 4303484.015000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 5694992.380000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 6475315.110000002,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 9590875.190000007,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 728000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 630044.1932740004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 649123.46,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1516484.0088890004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1493837,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1445199,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1458003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 417713.93356000003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 417937.44899999996,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 45158.8761662,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 45158.873500000016,
        },
      ],
    },
    {
      period: '2026/02',
      start: '2026-02-01T00:00:00.001Z',
      end: '2026-03-01T00:00:00.000Z',
      rows: [
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 86365180.6736,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 80468912.93539426,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 83412841.1771117,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 45454331.82999992,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 45288362.68999997,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 17707150.2,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 8112008.451100009,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 8054447.125,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 2417213.620000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 2658196.0000000005,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 7576000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 3317868.14,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 3342204,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 3408000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1451543.2437999998,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1583847.943,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 126000,
          sum: 15370950,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 9974947.529724443,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 11251144.210852196,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1016490.51,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1121450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 44014001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 4303484.015000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 5694992.380000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 6475315.110000002,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 9590875.190000007,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 728000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 630044.1932740004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 649123.46,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1516484.0088890004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1493837,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1445199,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1458003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 417713.93356000003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 417937.44899999996,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 45158.8761662,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 45158.873500000016,
        },
      ],
    },
    {
      period: '2026/03',
      start: '2026-03-01T00:00:00.001Z',
      end: '2026-04-01T00:00:00.000Z',
      rows: [
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 86365180.6736,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 80468912.93539426,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 83412841.1771117,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 45454331.82999992,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 45288362.68999997,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 17707150.2,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 8112008.451100009,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 8054447.125,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 2417213.620000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 2658196.0000000005,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 7576000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 3317868.14,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 3342204,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 3408000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1451543.2437999998,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1583847.943,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 139500,
          sum: 15510450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 9974947.529724443,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 11251144.210852196,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1016490.51,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1121450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 44014001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 4303484.015000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 5694992.380000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 6475315.110000002,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 9590875.190000007,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 728000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 630044.1932740004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 649123.46,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1516484.0088890004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1493837,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1445199,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1458003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 417713.93356000003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 417937.44899999996,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 45158.8761662,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 45158.873500000016,
        },
      ],
    },
    {
      period: '2026/04',
      start: '2026-04-01T00:00:00.001Z',
      end: '2026-05-01T00:00:00.000Z',
      rows: [
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 86365180.6736,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 80468912.93539426,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 83412841.1771117,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 45454331.82999992,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 45288362.68999997,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 17707150.2,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 8112008.451100009,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 8054447.125,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 2417213.620000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 2658196.0000000005,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 7576000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 3317868.14,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 3342204,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 3408000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1451543.2437999998,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1583847.943,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 135000,
          sum: 15645450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 9974947.529724443,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 11251144.210852196,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1016490.51,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1121450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 44014001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 4303484.015000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 5694992.380000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 6475315.110000002,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 9590875.190000007,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 728000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 630044.1932740004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 649123.46,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1516484.0088890004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1493837,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1445199,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1458003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 417713.93356000003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 417937.44899999996,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 45158.8761662,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 45158.873500000016,
        },
      ],
    },
    {
      period: '2026/05',
      start: '2026-05-01T00:00:00.001Z',
      end: '2026-06-01T00:00:00.000Z',
      rows: [
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 86365180.6736,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 80468912.93539426,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 83412841.1771117,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 45454331.82999992,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 45288362.68999997,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 17707150.2,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 8112008.451100009,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 8054447.125,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 2417213.620000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 2658196.0000000005,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 7576000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 3317868.14,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 3342204,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 3408000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1451543.2437999998,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1583847.943,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 103500,
          sum: 15748950,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 9974947.529724443,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 11251144.210852196,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1016490.51,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1121450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 44014001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 4303484.015000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 5694992.380000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 6475315.110000002,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 9590875.190000007,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 728000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 630044.1932740004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 649123.46,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1516484.0088890004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1493837,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1445199,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1458003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 417713.93356000003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 417937.44899999996,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 45158.8761662,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 45158.873500000016,
        },
      ],
    },
  ],
}

export const QUARTERLY_ANALYTICS_MOCK = {
  series: [
    {
      period: '2025/Q1',
      start: '2025-01-01T00:00:00.000Z',
      end: '2025-04-01T00:00:00.000Z',
      rows: [
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 86365180.6736,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 80468912.93539426,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 83412841.1771117,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 45454331.82999992,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 45288362.68999997,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 17707150.2,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 8112008.451100009,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 8054447.125,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 224359.53,
          sum: 2342494.410000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 382515.5,
          sum: 2353935.6,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 7576000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 3317868.14,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 3342204,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 3408000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1451543.2437999998,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1583847.943,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 405000.0000000007,
          sum: 13867950,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 9974947.529724443,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 11251144.210852196,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1016490.51,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1121450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 44014001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 4303484.015000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 5694992.380000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 850428.2799999999,
          sum: 6475315.110000002,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 1893442.3599999996,
          sum: 7465875.1700000055,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 728000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 630044.1932740004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 649123.46,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1516484.0088890004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1493837,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1445199,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1458003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 417713.93356000003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 417937.44899999996,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 45158.8761662,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 45158.873500000016,
        },
      ],
    },
    {
      period: '2025/Q2',
      start: '2025-04-01T00:00:00.001Z',
      end: '2025-07-01T00:00:00.000Z',
      rows: [
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 86365180.6736,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 80468912.93539426,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 83412841.1771117,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 45454331.82999992,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 45288362.68999997,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 17707150.2,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 8112008.451100009,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 8054447.125,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 74719.20999999999,
          sum: 2417213.620000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 304260.4,
          sum: 2658196.0000000005,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 7576000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 3317868.14,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 3342204,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 3408000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1451543.2437999998,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1583847.943,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 409499.99999999965,
          sum: 14277450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 9974947.529724443,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 11251144.210852196,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1016490.51,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1121450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 44014001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 4303484.015000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 5694992.380000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 6475315.110000002,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 2125000.0199999996,
          sum: 9590875.190000007,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 728000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 630044.1932740004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 649123.46,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1516484.0088890004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1493837,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1445199,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1458003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 417713.93356000003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 417937.44899999996,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 45158.8761662,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 45158.873500000016,
        },
      ],
    },
    {
      period: '2025/Q3',
      start: '2025-07-01T00:00:00.001Z',
      end: '2025-10-01T00:00:00.000Z',
      rows: [
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 86365180.6736,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 80468912.93539426,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 83412841.1771117,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 45454331.82999992,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 45288362.68999997,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 17707150.2,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 8112008.451100009,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 8054447.125,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 2417213.620000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 2658196.0000000005,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 7576000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 3317868.14,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 3342204,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 3408000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1451543.2437999998,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1583847.943,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 414000,
          sum: 14691450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 9974947.529724443,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 11251144.210852196,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1016490.51,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1121450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 44014001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 4303484.015000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 5694992.380000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 6475315.110000002,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 9590875.190000007,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 728000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 630044.1932740004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 649123.46,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1516484.0088890004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1493837,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1445199,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1458003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 417713.93356000003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 417937.44899999996,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 45158.8761662,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 45158.873500000016,
        },
      ],
    },
    {
      period: '2025/Q4',
      start: '2025-10-01T00:00:00.001Z',
      end: '2025-12-31T23:59:59.999Z',
      rows: [
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 86365180.6736,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 80468912.93539426,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 83412841.1771117,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 45454331.82999992,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 45288362.68999997,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 17707150.2,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 8112008.451100009,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 8054447.125,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 2417213.620000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 2658196.0000000005,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 7576000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 3317868.14,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 3342204,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 3408000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1451543.2437999998,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1583847.943,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 413999.99994791695,
          sum: 15105449.999947915,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 9974947.529724443,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 11251144.210852196,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1016490.51,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1121450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 44014001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 4303484.015000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 5694992.380000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 6475315.110000002,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 9590875.190000007,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 728000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 630044.1932740004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 649123.46,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1516484.0088890004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1493837,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1445199,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1458003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 417713.93356000003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 417937.44899999996,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 45158.8761662,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 45158.873500000016,
        },
      ],
    },
    {
      period: '2026/Q1',
      start: '2026-01-01T00:00:00.000Z',
      end: '2026-04-01T00:00:00.000Z',
      rows: [
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 86365180.6736,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 80468912.93539426,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 83412841.1771117,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 45454331.82999992,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 45288362.68999997,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 17707150.2,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 8112008.451100009,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 8054447.125,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 2417213.620000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 2658196.0000000005,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 7576000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 3317868.14,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 3342204,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 3408000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1451543.2437999998,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1583847.943,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 405000.00005208305,
          sum: 15510450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 9974947.529724443,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 11251144.210852196,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1016490.51,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1121450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 44014001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 4303484.015000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 5694992.380000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 6475315.110000002,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 9590875.190000007,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 728000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 630044.1932740004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 649123.46,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1516484.0088890004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1493837,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1445199,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1458003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 417713.93356000003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 417937.44899999996,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 45158.8761662,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 45158.873500000016,
        },
      ],
    },
    {
      period: '2026/Q2',
      start: '2026-04-01T00:00:00.001Z',
      end: '2026-05-24T00:00:00.000Z',
      rows: [
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 86365180.6736,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 80468912.93539426,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 83412841.1771117,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 45454331.82999992,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 45288362.68999997,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 17707150.2,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 8112008.451100009,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 8054447.125,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 2417213.620000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 2658196.0000000005,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 7576000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 3317868.14,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 3342204,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 3408000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1451543.2437999998,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1583847.943,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 238500,
          sum: 15748950,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 9974947.529724443,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 11251144.210852196,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1016490.51,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1121450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 44014001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 4303484.015000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 5694992.380000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 6475315.110000002,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 9590875.190000007,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 728000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 630044.1932740004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 649123.46,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1516484.0088890004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1493837,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1445199,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1458003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 417713.93356000003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 417937.44899999996,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 45158.8761662,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 45158.873500000016,
        },
      ],
    },
  ],
}

export const ANNUAL_ANALYTICS_MOCK = {
  series: [
    {
      period: '2025',
      start: '2025-01-01T00:00:00.000Z',
      end: '2026-01-01T00:00:00.000Z',
      rows: [
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 86365180.6736,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 80468912.93539426,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 83412841.1771117,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 45454331.82999992,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 45288362.68999997,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 17707150.2,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 8112008.451100009,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 8054447.125,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 299078.74,
          sum: 2417213.620000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 686775.8999999999,
          sum: 2658196.0000000005,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 7576000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 3317868.14,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 3342204,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 3408000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1451543.2437999998,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1583847.943,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 1642500.0000000005,
          sum: 15105450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 9974947.529724443,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 11251144.210852196,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1016490.51,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1121450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 44014001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 4303484.015000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 5694992.380000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 850428.2799999999,
          sum: 6475315.110000002,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 4018442.379999999,
          sum: 9590875.190000007,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 728000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 630044.1932740004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 649123.46,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1516484.0088890004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1493837,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1445199,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1458003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 417713.93356000003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 417937.44899999996,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 45158.8761662,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 45158.873500000016,
        },
      ],
    },
    {
      period: '2026',
      start: '2026-01-01T00:00:00.001Z',
      end: '2027-01-01T00:00:00.000Z',
      rows: [
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 86365180.6736,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 80468912.93539426,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 83412841.1771117,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 45454331.82999992,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/core-units',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 45288362.68999997,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 17707150.2,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 8112008.451100009,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 8054447.125,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 2417213.620000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/SUP',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 2658196.0000000005,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 7576000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 3317868.14,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 3342204,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/STA',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 3408000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1451543.2437999998,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1583847.943,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/GOV',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 643500,
          sum: 15748950,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 9974947.529724443,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 11251144.210852196,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1016490.51,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/PRO',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1121450,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 44014001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 4303484.015000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 5694992.380000001,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 6475315.110000002,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/scopes/ACC',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 9590875.190000007,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Budget',
          unit: 'DAI',
          value: 0,
          sum: 728000,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 630044.1932740004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 649123.46,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/spfs',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 1516484.0088890004,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 1493837,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 1445199,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/recognized-delegates',
            },
          ],
          metric: 'Forecast',
          unit: 'DAI',
          value: 0,
          sum: 1458003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 417713.93356000003,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 417937.44899999996,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/immutable/aligned-delegates',
            },
          ],
          metric: 'Actuals',
          unit: 'DAI',
          value: 0,
          sum: 0,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'PaymentsOnChain',
          unit: 'DAI',
          value: 0,
          sum: 45158.8761662,
        },
        {
          dimensions: [
            {
              name: 'budget',
              path: 'atlas/legacy/keepers',
            },
          ],
          metric: 'ProtocolNetOutflow',
          unit: 'DAI',
          value: 0,
          sum: 45158.873500000016,
        },
      ],
    },
  ],
}
